import { render, staticRenderFns } from "./Stat.vue?vue&type=template&id=544e736e&scoped=true"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"
import style0 from "./Stat.vue?vue&type=style&index=0&id=544e736e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544e736e",
  null
  
)

export default component.exports